import { render, staticRenderFns } from "./addAPI.vue?vue&type=template&id=0648bce8&scoped=true&"
import script from "./addAPI.vue?vue&type=script&lang=js&"
export * from "./addAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0648bce8",
  null
  
)

export default component.exports